<template>
  <ElTabs class="tab-default tab-sm" v-model="selectedTab">
    <Tab-pane :label="$t('PROFILE_LORRY_RECEIPT_ALLOCATION')" name="lorryReceipt">
      <lorry-receipt v-if="selectedTab === 'lorryReceipt'" v-on="$listeners" :lorryReceiptData="lorryReceiptData"/>
    </Tab-pane>
    <Tab-pane :label="$t('HSN_SAC')" name="hsnSac">
      <hsn-sac v-if="selectedTab === 'hsnSac'"/>
    </Tab-pane>
    <Tab-pane :label="$t('TRANSPORTER_PROFILE_STATE_WISE_GSTIN')" name="gstin">
        <gst v-if="selectedTab === 'gstin'" />
    </Tab-pane>
    <Tab-pane v-if="showEinvoice" :label="$t('E_INVOICE')" name="einvoice">
        <e-invoice v-if="selectedTab === 'einvoice'" />
    </Tab-pane>
    <Tab-pane v-if="showUpdateRolePermissions" :label="$t('ROLES')" name="rolepermission">
      <role-permission v-if="selectedTab === 'rolepermission'" />
    </Tab-pane>
  </ElTabs>
</template>
<script>
import LorryReceipt from './modules/LorryReceipt';
import Gst from './modules/Gst';
import HsnSac from './modules/HsnSac';
import EInvoice from './modules/E-Invoice';
import RolePermission from './modules/RolePermissions';

export default {
  components: {
    LorryReceipt,
    Gst,
    HsnSac,
    EInvoice,
    RolePermission,
  },
  props: {
    lorryReceiptData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedTab: 'lorryReceipt',
    };
  },
  computed: {
    showEinvoice() {
      return this.$hasFeature('e_invoice');
    },
    showUpdateRolePermissions() {
      return this.$hasPermission('update_user_permissions') && this.$hasFeature('show_profile_roles');
    },
  },
};
</script>
